export const FORM_IDS = {
  ADMIN_UPDATE_USER: "admin_update_user",
  AUTH_CHANGE_PASSWORD_LOGGED_OUT: "auth_change_password_logged_out",
  AUTH_FORGOT_PASSWORD: "auth_forgot_password",
  AUTH_LOGIN: "auth_login",
  AUTH_REGISTER: "auth_register",
  AUTH_RESET_PASSWORD: "auth_reset_password",
  COLLECTION_BREAKDOWN_REPORT: "collection_breakdown_report",
  CREATE_PATIENT: "create_patient",
  EDIT_PATIENT_MODAL: "edit_patient_modal",
  FINANCIAL_REPORT_PERFORMANCE: "financial_report_performance",
  FORECAST_ENTRY: "forecast_entry",
  MONTHLY_RECONCILIATION_REPORT: "monthly_reconciliation_report",
  PRACTITIONER_QUICK_LOOK: "practitioner_quick_look",
  PROFILE_CHANGE_PASSWORD: "profile_change_password",
  PROFILE_DIRECTORY_SEARCH: "profile_directory_search",
};
